/**
 * @type {Object}
 * @property {array}  deliverynotes  Delivery Note data
 */
 const initialState = {
    deliverynotes: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerDeliveryNote = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_DELIVERY_NOTES':
            var { data } = action;
            newState.deliverynotes = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerDeliveryNote;